import { instructionsExist } from '../../../app-integration-instructions/local/paths';

/** @ngInject */
export function Controller(
    $scope,
    $state,
    $timeout,
) {
    this.$onInit = () => {
        this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');

        this.localInstructionsExist = instructionsExist(this.application.applicationType.slug);

    var initIntegrationOverviewTab = function(){
        $('.apiKey.redirectDestructive').click(function(event) {
            event.preventDefault();
            $state.go('^.app-key-password');
        });
    };

    $timeout( function(){
        initIntegrationOverviewTab();
    }, 1000);


        $scope.$on('language-loaded', () => {
            $state.reload('company.manage-application');
        });

    $('#configuration').on('click', '#simulator', function(event) {
        event.preventDefault();
        $state.go('company.manage-application.integration-developers.simulators');
    });

    $('#configuration').on('click', '#widget', function(event) {
        event.preventDefault();
        $state.go('company.manage-application.integration-developers.widgets');
    });

    $('#configuration').on('click', '#otp', function(event) {
        event.preventDefault();
        $state.go('company.manage-application.developers.otp');
    });

    $('#configuration').on('click', '#goToConfiguration', function(event) {
        event.preventDefault();
        $state.go('company.manage-application.configuration');
    });

    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration/application-integration.controller.js